module.exports = "/images/toggle.svg?9c1002c4ed0622eb054faab6be92d129";